/* eslint-disable import/prefer-default-export */
import fetchErrorHandler from '../services/fetchErrorHandler';
import {
  SET_ADMISSION_PROCESSES,
  ADD_ADMISSION_PROCESSES,
  ADMISSION_PROCESS_API_REQUEST,
  ADMISSION_PROCESS_API_SUCCESS,
  ADMISSION_PROCESS_API_FAILURE,
} from './actionTypes';
import { getCsrfToken } from '../utils/helpers';

const admissionProcessApiRequest = () => ({
  type: ADMISSION_PROCESS_API_REQUEST,
});

const admissionProcessApiSuccess = ({ count, results }) => ({
  type: ADMISSION_PROCESS_API_SUCCESS,
  payload: {
    count,
    results,
  },
});

const admissionProcessApiFailure = ({ error }) => ({
  type: ADMISSION_PROCESS_API_FAILURE,
  error,
});

const setAdmissionProcesses = ({ count, results }) => ({
  type: SET_ADMISSION_PROCESSES,
  payload: {
    count,
    results,
  },
});

const addAdmissionProcesses = ({ count, results }) => ({
  type: ADD_ADMISSION_PROCESSES,
  payload: {
    count,
    results,
  },
});

export const getAdmissionProcesses = () => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  // const { applicationId } = getState().user;
  const url = `${locale}/api/${apiVersion}/admissionprocesses`;
  dispatch(admissionProcessApiRequest());
  return fetch(url, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(admissionProcesses => {
      const { count, results } = admissionProcesses;
      dispatch(
        addAdmissionProcesses({
          count,
          results,
        }),
      );
      // dispatch(setAdmissionProcesses({ count, results }));
      dispatch(admissionProcessApiSuccess({ count, results }));
    })
    .catch(error => {
      console.error('error', error);
      dispatch(admissionProcessApiFailure({ error }));
    });
};

export default getAdmissionProcesses;
